import { fieldType, actionType } from './enums';

import { rootActions } from './ddeManager';

export function triggerDde(rules, actions, fields, fvlFields, trigger) {
  // eslint-disable-next-line func-names
  const criteriaFields = fields.map(function(field) {
    return field.id;
  });
  let newValueAssigned = false;
  // update fields and fvlfields with latest value selected for trigger field
  fields.some(field => {
    if (field.id === trigger.fieldID)
      switch (field.fieldType) {
        case fieldType.Text:
          // eslint-disable-next-line no-param-reassign
          field.text_value = trigger.newValue;
          newValueAssigned = true;
          break;
        case fieldType.Numeric:
          // eslint-disable-next-line no-param-reassign
          field.numeric_value = trigger.newValue;
          newValueAssigned = true;
          break;
        case fieldType.ValuesList:
          {
            // eslint-disable-next-line no-param-reassign
            field.values = trigger.newValue;
            newValueAssigned = true;
            let updateFvl = false;
            fvlFields.some(fvl => {
              if (fvl.id === trigger.fieldID) {
                // eslint-disable-next-line no-param-reassign
                fvl.value = trigger.newValue;
                updateFvl = true;
              }
              return updateFvl;
            });
            if (!updateFvl) {
              const fvlActions = actions?.filter(f => f.action_type === actionType.FilterValuesList && f.portal_field_id === trigger.fieldID);
              if (fvlActions != null && fvlActions.length > 0) {
                const fvlField = {
                  field_id: field.field_id,
                  id: field.id,
                  fieldType: field.fieldType,
                  __typename: field.__typename,
                  value: field.values
                };
                fvlFields.push(fvlField);
              }
            }
            // eslint-disable-next-line no-param-reassign
            fvlFields = fvlFields.filter(f => f.value?.some(v => v != null));
          }
          break;
        case fieldType.Date:
          // eslint-disable-next-line no-param-reassign
          field.date_value = trigger.newValue;
          newValueAssigned = true;
          break;
        default:
          break;
      }
    return newValueAssigned;
  });

  const fvlFieldsValueMap = new Map(
    fvlFields.map(field => {
      return [field.field_id, field.value];
    })
  );
  const result = rootActions(rules, actions, fields, trigger, fvlFieldsValueMap, criteriaFields);
  return result;
}

export default {
  triggerDde
};
